import React, { useState } from "react";
import { v4 as uuid } from "uuid";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { formValidator } from "../../../../helpers";
import { Modal, Button, InputGroup } from "../../../../UI";
import { createAnnouncement, updateAnnouncement } from "../../../../redux/actions";
import Container from "./style";

const ModalContent = ({ action, announcements }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const activeData =
    location.state && location.state.id
      ? announcements.find((item) => item.id === location.state.id)
      : {};
  const [loading, setLoading] = useState(false);
  const [formData, setFormState] = useState(() =>
    action === "edit"
      ? {
          ...activeData,
          start_date: activeData.start_date ? activeData.start_date.split("T")[0] : "",
          end_date: activeData.end_date ? activeData.end_date.split("T")[0] : "",
          is_active: activeData.is_active ? 1 : 0,
        }
      : {
          title: "",
          body: "",
          start_date: new Date().toISOString().split("T")[0],
          end_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split("T")[0],
          is_active: 1,
          action_url: "",
          image: null,
          id: uuid(),
        }
  );

  const handleInput = ({ target: { name, value, files } }) => {
    if (name === "image") {
      setFormState((s) => ({ ...s, [name]: files[0] }));
    } else {
      setFormState((s) => ({ ...s, [name]: value }));
    }
  };

  const handleSubmit = async () => {
    const formElements = document.forms["announcement-form"].elements;
    const requiredElements = Array.from(formElements).filter(el => el.required);
    
    if (formValidator(requiredElements)) {
      try {
        setLoading(true);
        const response =
          action === "edit"
            ? await dispatch(updateAnnouncement(formData.id, { ...formData }))
            : await dispatch(createAnnouncement({ ...formData }));
        if (response && response.success === true) {
          history.goBack();
        }
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Container>
      <Modal
        showModal={true}
        modalTitle={
          action === "edit" ? `Edit Announcement` : "New Announcement"
        }
        modalFooter={
          <Button form="announcement-form" loading={loading} full type="submit">
            {action === "edit" ? "Save" : "Create"}
          </Button>
        }
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
          id="announcement-form"
          name="announcement-form"
          noValidate
        >
          <InputGroup
            label="Title"
            name="title"
            required={true}
            onChange={handleInput}
            value={formData.title}
          />
          <InputGroup>
            <label>Announcement Body</label>
            <textarea
              name="body"
              required={true}
              value={formData.body}
              onChange={handleInput}
              style={{ width: "100%", minHeight: "100px", padding: "10px", borderRadius: "4px", border: "1px solid #d9d9d9" }}
            />
          </InputGroup>
          <div style={{ display: "flex", gap: "10px" }}>
            <InputGroup
              label="Start Date"
              type="date"
              name="start_date"
              required={true}
              onChange={handleInput}
              value={formData.start_date}
              style={{ flex: 1 }}
            />
            <InputGroup
              label="End Date"
              type="date"
              name="end_date"
              required={true}
              onChange={handleInput}
              value={formData.end_date}
              style={{ flex: 1 }}
            />
          </div>
          <InputGroup
            label="Image"
            type="file"
            name="image"
            onChange={handleInput}
            accept="image/*"
          />
          <InputGroup
            label="Action URL (Optional)"
            name="action_url"
            onChange={handleInput}
            value={formData.action_url}
          />
          <InputGroup>
            <label>Status</label>
            <select
              name="is_active"
              onChange={handleInput}
              value={formData.is_active}
            >
              <option value={1}>Active</option>
              <option value={0}>Inactive</option>
            </select>
          </InputGroup>
        </form>
      </Modal>
    </Container>
  );
};

export default ModalContent;
